import { CONSTANTS } from 'utils';
import { IModuleRoute, RoleTypes, AppRouteNamesList } from 'models';

const requiredRoles = [RoleTypes.PRIMARY_ADMIN, RoleTypes.ADMIN];

enum TemplatesPathList {
	templates = '/templates',
	edit = '/edit',
	new = '/new',
	scheduling = '/scheduling',
	surveyScheduling = '/edit',
}

export const templatesRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${TemplatesPathList.templates}`,
	name: AppRouteNamesList.templates,
	requiredRoles,
	nested: [
		{
			path: TemplatesPathList.edit,
			name: AppRouteNamesList.templatesEdit,
			requiredRoles,
		},
		{
			path: TemplatesPathList.new,
			name: AppRouteNamesList.templatesNew,
			requiredRoles,
		},
		{
			path: TemplatesPathList.scheduling,
			name: AppRouteNamesList.templateScheduling,
			requiredRoles,
		},
		{
			path: `${TemplatesPathList.scheduling}${TemplatesPathList.surveyScheduling}`,
			name: AppRouteNamesList.surveyScheduling,
			requiredRoles,
		},
	],
};
